import { render, staticRenderFns } from "./LoadMoreButtonContainer.vue?vue&type=template&id=1b564338&"
import script from "./LoadMoreButtonContainer.vue?vue&type=script&lang=ts&"
export * from "./LoadMoreButtonContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports